import type { PageLoad } from './$types';
import { env } from '$env/dynamic/public';
import { routesPagename } from '$lib/services/urls/routesPagename';
import { redirect } from '@sveltejs/kit';

export const load = (async () => {
	if (env.PUBLIC_FEATURE_REGISTER_MY_CAR_ENABLED !== 'true') {
		redirect(302, `/`);
	}

	return {
		pagename: routesPagename.ADD_VEHICLE,
	};
}) satisfies PageLoad;
